// extracted by mini-css-extract-plugin
export default {"faqListBox":"FaqList_faqListBox__txsyY","card":"FaqList_card__Frt1j","cardContent":"FaqList_cardContent__7MES2","cKEditorContent":"FaqList_cKEditorContent__q+AvP"};